module.exports = __webpack_public_path__ + "img/smartButton.89788c31.svg";